var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.hideDefaultIcon && !_vm.source)?_c('i',{staticClass:"fas",class:'fa-' + _vm.defaultIcon}):_vm._e(),(_vm.source)?_c('img',{attrs:{"src":_vm.source,"width":"24","height":"24","title":_vm.specialist.name}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }